import { render, staticRenderFns } from "./share.vue?vue&type=template&id=b1d4c5ea&scoped=true&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style0 from "./share.vue?vue&type=style&index=0&id=b1d4c5ea&scoped=true&lang=css&"
import style1 from "./share.vue?vue&type=style&index=1&id=b1d4c5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d4c5ea",
  null
  
)

export default component.exports